import { useAppSelector } from '../../store/hooks'

export const useBroadcasting = () => {
  const broadcasting = useAppSelector((state) => state.broadcasting)
  return broadcasting
}
